<app-main-content mode="1col" class="gsm">

  <gsm-overview
    [isKbma]="isKbma"
    [isDeleteDisabled]="isDeleteDisabled"
    [schadenUebersicht]='schadenUebersicht'
    [schadenEntwurf]='entwurfUebersicht'
    [schadenOverviewIsLoading]='schadenUebersichtIsLoading'
    [entwurfOverviewIsLoading]='entwurfUebersichtIsLoading'
    [schwebebestand]='schwebebestand'
    [highlightedSchadenNummer]='highlightedSchadenNummer'
    (selectSchaden)='handleSelect($event)'
    (deleteSchaden)='deleteSchadenEvent($event)'
    (deleteAllEntwuerfe)='deleteAllEntwuerfe()'
    (printSchaden)='printSchaden($event)'
    (showEsignDialog)='showEsignDialog($event)'
    (toggleGsmNotification)="toggleGsmNotification($event)"
    (toggleArge)='toggleARGE()'
    (schadenMelden)='schadenMelden()'>
  </gsm-overview>

</app-main-content>
